<div class="not-found-container">
  <div class="not-found-content">
    <div class="error-code">404</div>
    <div class="error-illustration">
      <div class="astronaut">
        <div class="helmet"></div>
        <div class="body"></div>
        <div class="arm left"></div>
        <div class="arm right"></div>
        <div class="leg left"></div>
        <div class="leg right"></div>
      </div>
      <div class="stars">
        <div class="star" style="top: 10%; left: 20%;"></div>
        <div class="star" style="top: 30%; left: 80%;"></div>
        <div class="star" style="top: 60%; left: 10%;"></div>
        <div class="star" style="top: 80%; left: 70%;"></div>
        <div class="star" style="top: 20%; left: 50%;"></div>
      </div>
    </div>
    <h1 class="error-title">Oops! Page Not Found</h1>
    <p class="error-description">
      The page you're looking for seems to have vanished in the digital void. 
      Don't worry, even the best explorers get lost sometimes!
    </p>
    <div class="action-buttons">
      <button class="btn-primary" (click)="goHome()">
        <span class="btn-icon">🏠</span>
        Go Home
      </button>
      <button class="btn-secondary" (click)="goBack()">
        <span class="btn-icon">←</span>
        Go Back
      </button>
    </div>
  </div>
</div>
